export const tourQuest = {
    id: 'Tour',
    slug: 'tour',
    titleKey: 'chapter_tour',
    shortName: 'TOUR',
    date: '10.05.2026',
    status: 'locked',
    heroImage: '/Story/Tour/Tour-Overview.png',
    questMap: [
        {
            id: 'Ground_zero',
            label: {
                en: "Ground Zero (Tutorial)",
                tr: "Ground Zero (Eğitim)",
                ru: "Ground Zero (Обучение)"
            },
            type: 'start',
            isSubTask: false,
            details: {
               location: { en: "Ground Zero", tr: "Ground Zero", ru: "Эпицентр" },
                objective: {
                    en: "Finish the tutorial raid by extracting via the 'Klimov Street' extraction which is located behind the 'Skyside' business center.",
                    tr: "Eğitim baskınını, 'Skyside' iş merkezinin arkasında bulunan 'Klimov Street' çıkış noktasını kullanarak tamamla.",
                    ru: "Завершите обучающий рейд, выйдя через выход «улица Климова», расположенный за бизнес-центром «Skyside»."
                },
                warning: {
                    en: "During the tutorial, numerous hints on controls and game mechanics are displayed, but none of them need to be followed in order to complete the raid.",
                    tr: "Eğitim sırasında birçok ipucu gösterilir ancak baskını tamamlamak için bunları takip etmenize gerek yoktur.",
                    ru: "Во время обучения отображаются подсказки, но их не обязательно выполнять для завершения рейда."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Extract via the 'Klimov Street' extraction.",
                            tr: "'Klimov Street' üzerinden çıkış yap.",
                            ru: "Выйдите через выход «улица Климова»."
                        },
                        images: ['/Story/Tour/Step1-SubStep1-1.webp']
                    }
                ]
            }
        },
        {
            id: 'Therapist_Payment',
            label: {
                en: "Unlocking Streets of Tarkov",
                tr: "Streets of Tarkov'u Açmak",
                ru: "Разблокировка Streets of Tarkov"
            },
            type: 'task',
            isSubTask: false,
            details: {
location: { en: "Menu", tr: "Menü", ru: "Меню" },
                objective: {
                    en: "Visit Therapist in the menu through the trader screen and hand over 250,000 Roubles when the dialogue option appears.",
                    tr: "Menüden Therapist'i ziyaret et ve 250.000 Ruble teslim et.",
                    ru: "Посетите Терапевта и передайте 250 000 рублей."
                },
                rewards: {
                    en: "Unlocks Streets of Tarkov in the location selection.",
                    tr: "Harita seçiminde Streets of Tarkov kilidi açılır.",
                    ru: "Открывает Streets of Tarkov в выборе локации."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Hand over 250,000 Roubles to Therapist.",
                            tr: "Therapist'e 250.000 Ruble ver.",
                            ru: "Передайте Терапевту 250 000 рублей."
                        }
                    }
                ]
            }
        },
        {
            id: 'Ragman_Interchange',
            label: {
                en: "Unlocking Skier & Customs",
                tr: "Skier ve Customs'ı Açmak",
                ru: "Разблокировка Лыжника и Таможни"
            },
            type: 'task',
            isSubTask: false,
            details: {
location: { en: "Interchange", tr: "Değişim", ru: "Развязка" },
                objective: {
                    en: "Extract from Interchange with either the 'Survived' or 'Run-Through' extraction status, or visit the location 3 times.",
                    tr: "Interchange haritasından 'Survived' veya 'Run-Through' statüsüyle çıkış yap ya da haritayı 3 kez ziyaret et.",
                    ru: "Выйдите с локации Развязка (Выжил / Пробежка) или посетите ее 3 раза."
                },
                rewards: {
                    en: "Unlocks Skier as trader. Unlocks Customs in the location selection.",
                    tr: "Skier (Tüccar) ve Customs (Harita) kilidi açılır.",
                    ru: "Открывает Лыжника и Таможню."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Extract from Interchange or visit 3 times.",
                            tr: "Interchange'den canlı çık veya 3 kere ziyaret et.",
                            ru: "Выйдите с Развязки или посетите 3 раза."
                        }
                    }
                ]
            }
        },
        {
            id: 'Skier_Customs',
            label: {
                en: "Unlocking Mechanic & Factory",
                tr: "Mechanic ve Factory'yi Açmak",
                ru: "Разблокировка Механика и Завода"
            },
            type: 'task',
            isSubTask: false,
            details: {
location: { en: "Customs", tr: "Gümrük", ru: "Таможня" },
                requiredItems: [
                    {
                        en: "5x Any building materials or tools (FIR)",
                        tr: "5x Herhangi bir inşaat malzemesi veya alet (FIR)",
                        ru: "5x Любые строительные материалы или инструменты (FIR)"
                    }
                ],
                objective: {
                    en: "Hand over 5 building materials or tools (Found in Raid). Extract from Customs with 'Survived' or 'Run-Through', or visit 3 times.",
                    tr: "Baskında bulunmuş (FIR) 5 adet inşaat malzemesi/alet teslim et. Customs'dan canlı çık veya 3 kez ziyaret et.",
                    ru: "Передайте 5 строительных материалов/инструментов (FIR). Выйдите с Таможни или посетите 3 раза."
                },
                rewards: {
                    en: "Unlocks Mechanic as trader. Unlocks Factory in the location selection.",
                    tr: "Mechanic (Tüccar) ve Factory (Harita) kilidi açılır.",
                    ru: "Открывает Механика и Завод."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Give 5 FIR building materials/tools to Skier. Partial handover not possible.",
                            tr: "Skier'a 5 adet FIR inşaat malzemesi ver. Parçalı teslimat yapılamaz.",
                            ru: "Отдайте Лыжнику 5 строительных материалов (FIR). Частичная передача невозможна."
                        }
                    },
                    {
                        text: {
                            en: "Extract from Customs or visit 3 times.",
                            tr: "Customs'dan canlı çık veya 3 kere ziyaret et.",
                            ru: "Выйдите с Таможни или посетите 3 раза."
                        }
                    }
                ]
            }
        },
        {
            id: 'Mechanic_Factory',
            label: {
                en: "Unlocking Prapor & Woods",
                tr: "Prapor ve Woods'u Açmak",
                ru: "Разблокировка Прапора и Леса"
            },
            type: 'task',
            isSubTask: false,
            details: {
location: { en: "Factory", tr: "Fabrika", ru: "Завод" },
                requiredItems: [
                    {
                        en: "2x Any weapons (FIR)",
                        tr: "2x Herhangi bir silah (FIR)",
                        ru: "2x Любое оружие (FIR)"
                    }
                ],
                objective: {
                    en: "Hand over 2 weapons (Found in raid). Extract from Factory with 'Survived' or 'Run-Through', or visit 3 times.",
                    tr: "Baskında bulunmuş (FIR) 2 adet silah teslim et. Factory'den canlı çık veya 3 kez ziyaret et.",
                    ru: "Передайте 2 единицы оружия (FIR). Выйдите с Завода или посетите 3 раза."
                },
                rewards: {
                    en: "Unlocks Prapor as trader. Unlocks Woods in the location selection.",
                    tr: "Prapor (Tüccar) ve Woods (Harita) kilidi açılır.",
                    ru: "Открывает Прапора и Лес."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Hand over 2 FIR weapons to Mechanic.",
                            tr: "Mechanic'e 2 adet FIR silah ver.",
                            ru: "Отдайте Механику 2 единицы оружия (FIR)."
                        }
                    },
                    {
                        text: {
                            en: "Extract from Factory or visit 3 times.",
                            tr: "Factory'den canlı çık veya 3 kere ziyaret et.",
                            ru: "Выйдите с Завода или посетите 3 раза."
                        }
                    }
                ]
            }
        },
        {
            id: 'Skier_Woods',
            label: {
                en: "Unlocking Peacekeeper & Shoreline",
                tr: "Peacekeeper ve Shoreline'ı Açmak",
                ru: "Разблокировка Миротворца и Берега"
            },
            type: 'task',
            isSubTask: false,
            details: {
location: { en: "Woods", tr: "Ormanlık", ru: "Лес" },                objective: {
                    en: "Kill any 3 targets on Woods and extract with either the 'Survived' or 'Run-Through' extraction status, or visit the location 3 times.",
                    tr: "Woods haritasında 3 hedefi öldür ve çıkış yap ya da haritayı 3 kez ziyaret et.",
                    ru: "Убейте 3 цели на Лесу и выйдите, либо посетите локацию 3 раза."
                },
                rewards: {
                    en: "Unlocks Peacekeeper as trader. Unlocks Shoreline in the location selection.",
                    tr: "Peacekeeper (Tüccar) ve Shoreline (Harita) kilidi açılır.",
                    ru: "Открывает Миротворца и Берег."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Kill 3 targets. The kills don't need to be performed in the same raid as the 'survive' objective.",
                            tr: "3 hedefi öldür. Öldürme işlemlerini sağ çıkış yaptığın baskınla aynı anda yapmak zorunda değilsin.",
                            ru: "Убейте 3 цели. Убийства не обязательно совершать в том же рейде, где нужно выжить."
                        }
                    }
                ]
            }
        },
        {
            id: 'Terminal',
            label: {
                en: "Terminal Exploration",
                tr: "Terminal Keşfi",
                ru: "Исследование Терминала"
            },
            type: 'task',
            isSubTask: false,
            details: {
location: { en: "Shoreline", tr: "Kıyı Şeridi", ru: "Берег" },                objective: {
                    en: "Go to the south-east corner of Shoreline and interact with the intercom at the watchtower in front of the Terminal.",
                    tr: "Shoreline'ın güneydoğu köşesine git ve Terminalin önündeki gözetleme kulesindeki interkom ile etkileşime geç.",
                    ru: "Отправляйтесь в юго-восточный угол Берега и взаимодействуйте с интеркомом на сторожевой башне."
                },
                warning: {
                    en: "Be careful not to get too close to the Terminal wall, as there are guards that will shoot at anyone. Do not try to kill them, they return fire with deadly precision. Interacting with the intercom too many times after being told to leave will also lead to your death by the guards.",
                    tr: "Terminal duvarına çok yaklaşma, korumalar herkese ateş açar. Onları öldürmeye çalışma. Gitmen söylendikten sonra interkomla çok fazla etkileşime girmek de ölümüne sebep olur.",
                    ru: "Не подходите слишком близко к стене Терминала. Не пытайтесь их убить. Слишком частое взаимодействие с интеркомом также приведет к вашей смерти."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Interact with the intercom at the watchtower.",
                            tr: "Gözetleme kulesindeki interkomu kullan.",
                            ru: "Взаимодействуйте с интеркомом на сторожевой башне."
                        },
                        images: [
                            '/Story/Tour/Step7-SubStep1-1.webp',
                            '/Story/Tour/Step7-Substep1-2.webp',
                            '/Story/Tour/Step7-SubStep1-3.webp'
                        ]
                    }
                ]
            }
        },
        {
            id: 'Prapor_Reserve',
            label: {
                en: "Unlocking Reserve",
                tr: "Reserve'i Açmak",
                ru: "Разблокировка Резерва"
            },
            type: 'task',
            isSubTask: false,
            details: {
                    location: { en: "Shoreline", tr: "Kıyı Şeridi", ru: "Берег" },
                requiredItems: [
                    {
                        en: "5x Dogtag",
                        tr: "5x Dogtag (Künye)",
                        ru: "5x Жетоны"
                    }
                ],
                objective: {
                    en: "Extract from Shoreline ('Survived'/'Run-Through') or visit 3 times. Hand over 5 Dogtags to Prapor.",
                    tr: "Shoreline'dan canlı çık veya 3 kere ziyaret et. Prapor'a 5 adet Dogtag teslim et.",
                    ru: "Выйдите с Берега или посетите 3 раза. Передайте Прапору 5 жетонов."
                },
                rewards: {
                    en: "Unlocks Reserve in the location selection.",
                    tr: "Reserve (Harita) kilidi açılır.",
                    ru: "Открывает Резерв в выборе локации."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Extract from Shoreline or visit 3 times.",
                            tr: "Shoreline'dan çıkış yap veya 3 kez ziyaret et.",
                            ru: "Выйдите с Берега или посетите 3 раза."
                        }
                    },
                    {
                        text: {
                            en: "Hand over 5 Dogtags. The Dogtags can be obtained by taking them off dead PMCs (they do not have to be killed by your hand).",
                            tr: "5 adet Dogtag ver. (Kendi öldürmediğin PMC cesetlerinden de alabilirsin).",
                            ru: "Передайте 5 жетонов. Жетоны можно снять с мертвых ЧВК (не обязательно убитых вами)."
                        }
                    }
                ]
            }
        },
        {
            id: 'Mechanic_Lighthouse',
            label: {
                en: "Unlocking Lighthouse",
                tr: "Lighthouse'u Açmak",
                ru: "Разблокировка Маяка"
            },
            type: 'task',
            isSubTask: false,
            details: {
location: { en: "Menu", tr: "Menü", ru: "Меню" },                requiredItems: [
                    {
                        en: "20,000 Dollars",
                        tr: "20.000 Dolar",
                        ru: "20,000 Долларов"
                    }
                ],
                objective: {
                    en: "Visit Mechanic in the menu through the trader screen and hand over 20,000 Dollars.",
                    tr: "Tüccar menüsünden Mechanic'i ziyaret et ve 20.000 Dolar teslim et.",
                    ru: "Посетите Механика в меню и передайте 20 000 долларов."
                },
                rewards: {
                    en: "Unlocks Lighthouse in the location selection.",
                    tr: "Lighthouse (Harita) kilidi açılır.",
                    ru: "Открывает Маяк в выборе локации."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Hand over 20,000 Dollars to Mechanic. Dollars can be purchased from Peacekeeper with Roubles.",
                            tr: "Mechanic'e 20.000 Dolar ver. (Dolarları Peacekeeper'dan satın alabilirsin).",
                            ru: "Передайте 20 000 долларов Механику. Доллары можно купить у Миротворца."
                        }
                    }
                ]
            }
        },
        {
            id: 'Secret_TerraGroup_Lab',
            label: {
                en: "Unlocking The Lab",
                tr: "The Lab'i Açmak",
                ru: "Разблокировка Лаборатории"
            },
            type: 'task',
            isSubTask: false,
            details: {
location: { en: "The Lab", tr: "Laboratuvar", ru: "Лаборатория" },                requiredItems: [
                    {
                        en: "1x TerraGroup Labs access keycard",
                        tr: "1x TerraGroup Labs giriş kartı",
                        ru: "1x Ключ-карта TerraGroup Labs"
                    }
                ],
                objective: {
                    en: "Access The Lab via transit from Streets of Tarkov or Factory. Search O21, server room, and locate escape path.",
                    tr: "Transit kullanarak (Streets veya Factory üzerinden) The Lab'e gir. O21 ofisini, sunucu odasını ara ve kaçış yolunu bul.",
                    ru: "Попадите в Лабораторию транзитом. Осмотрите офис O21, серверную и найдите путь побега."
                },
                rewards: {
                    en: "Unlocks The Lab in the location selection. Unlocks achievement Pathfinder.",
                    tr: "The Lab (Harita) ve Pathfinder (Başarım) kilidi açılır.",
                    ru: "Открывает Лабораторию и достижение Pathfinder."
                },
                warning: {
                    en: "TerraGroup Labs access keycard required. Transits are only available 1 min after raid start.",
                    tr: "Giriş için Lab Keycard gereklidir. Transit geçişler baskın başladıktan 1 dakika sonra aktif olur.",
                    ru: "Требуется карта доступа. Транзиты доступны только через 1 мин после начала рейда."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Transit to The Lab via Streets (Underground entrance in front of Klimova 16A) or Factory (sewer tunnel).",
                            tr: "Streets (Klimova 16A altı) veya Factory (Kanalizasyon) üzerinden Lab'e transit geçiş yap.",
                            ru: "Перейдите в Лабораторию транзитом через Streets или Factory."
                        },
                        images: [
                            '/Story/Tour/Step10-SubStep1-1.webp',
                            '/Story/Tour/Step10-SubStep1-2.webp',
                            '/Story/Tour/Step10-SubStep1-3.webp',
                            '/Story/Tour/Step10-SubStep1-4.webp'
                        ]
                    },
                    {
                        text: {
                            en: "Search the top management offices (Laboratory manager's office O21 on the second level).",
                            tr: "İkinci kattaki Laboratuvar müdürü ofisini (O21) ara.",
                            ru: "Осмотрите офис менеджера (O21) на втором уровне."
                        },
                        images: ['/Story/Tour/Step10-SubStep2-1.webp']
                    },
                    {
                        text: {
                            en: "Search the server room (Next to the hangar on the first level).",
                            tr: "Birinci katta hangarın yanındaki sunucu odasını ara.",
                            ru: "Осмотрите серверную комнату (рядом с ангаром)."
                        }
                    },
                    {
                        text: {
                            en: "Locate the escape path through the drainage (Sewage Conduit). The extraction does not need to be activated... You do not need to survive the raid.",
                            tr: "Kanalizasyondaki kaçış yolunu bul. Çıkışı aktive etmene veya canlı çıkmana gerek yok.",
                            ru: "Найдите путь побега через канализацию. Выживать в рейде не обязательно."
                        },
                        images: ['/Story/Tour/Step10-SubStep4-1.webp']
                    }
                ]
            }
        }
    ]
};
